var map = {
	"./2018-07-annual-beer-festival-banner.png": 3479,
	"./2018-07-annual-beer-festival-thumbnail.jpg": 9715,
	"./2019-05-sash-sleep-out-banner.jpg": 9956,
	"./2019-05-sash-sleep-out-banner.png": 3643,
	"./2019-05-sash-sleep-out-thumbnail.jpg": 1009,
	"./2019-11-charity-quiz-and-curry-night-banner.jpg": 5735,
	"./2019-11-charity-quiz-and-curry-night-thumbnail.jpg": 4464,
	"./2021-01-christmas-tree-collection-banner.jpg": 6813,
	"./2021-01-christmas-tree-collection-thumbnail.jpg": 3552,
	"./2021-11-charity-quiz-and-curry-night-banner.jpg": 115,
	"./2021-11-charity-quiz-and-curry-night-thumbnail.jpg": 3179
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4213;